import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import Countdown from 'react-countdown'

import useStyles from './styles'


const CountDown = (props) => {
  const classes = useStyles(props)
  const { className, countDownDate, countDownProps } = props

  return (
    <time
      className={cx(className, classes.container)}
      dateTime={countDownDate}
    >
      <Countdown
        className={classes.countDown}
        date={new Date(Date.parse(countDownDate))}
        {...countDownProps}
      />
    </time>
  )
}

CountDown.propTypes = {
  className: PropTypes.string,
  countDownDate: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  countDownProps: PropTypes.object,
}

CountDown.defaultProps = {
  className: null,
  countDownDate: null,
  countDownProps: null,
}

export default CountDown
